import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { TestWebhookBodySchema, TestWebhookResponseDataSchema } from "schema"
import z from "zod"

type Response = {
  data: z.infer<typeof TestWebhookResponseDataSchema>
}

type Props = {
  onSuccess?: (response: string) => void
  onError?: (error: unknown) => void
}

export function useTestWebhookMutation({ onSuccess, onError }: Props = {}) {
  return useMutation({
    mutationFn: async (data: z.input<typeof TestWebhookBodySchema>) => {
      const response = await axios.post<Response>("/capabilities/test-webhook", data)

      if (response.data.data.valid) {
        onSuccess?.(response.data.data.responseBody ?? "{}")
      } else {
        onError?.(response.data.data.error)
      }

      return response.data.data
    },
  })
}
